import { Component, Input, TemplateRef, ChangeDetectionStrategy } from "@angular/core";
import { VirkeskopAffarsformer } from "~app/common/models/constants";
import { ISearchResponseRow, ISearchResultRenderer } from "../../quick-search.models";
import { NgbPopover } from "@ng-bootstrap/ng-bootstrap";

@Component({
    selector: "rask-virkeskopskontrakt-renderer",
    templateUrl: "./virkeskopskontrakt-renderer.component.html",
    styleUrls: ["../default-renderer.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [NgbPopover]
})
export class VirkeskopskontraktRendererComponent implements ISearchResultRenderer {
    @Input() input: ISearchResponseRow;
    @Input() tooltipTemplate: TemplateRef<any>;

    private readonly affarsformMetadataKey = "affarsform";

    getAffarsformShort() {
        const affarsform = this.input.metadata[this.affarsformMetadataKey];
        switch (affarsform) {
            case VirkeskopAffarsformer.AuFastKostnad:
                return VirkeskopAffarsformer.AuFastKostnadForShort;
            case VirkeskopAffarsformer.AuSjalvkostnad:
                return VirkeskopAffarsformer.AuSjalvkostnadForShort;
            case VirkeskopAffarsformer.Leveransrotkop:
                return VirkeskopAffarsformer.LeveransrotkopForShort;
            case VirkeskopAffarsformer.Leveransvirke:
                return VirkeskopAffarsformer.LeveransvirkeForShort;
            case VirkeskopAffarsformer.Rotpost:
                return VirkeskopAffarsformer.RotpostForShort;
            default:
                return undefined;
        }
    }
}
